// 引入加密文件
import CryptoJS from "../../public/crypto-js";

/**
 * @name:crypto-js 加密
 * @author: camellia
 * @email: guanchao_gc@qq.com
 * @date: 2021-01-22
 */
export default param => {
    var text = JSON.stringify(param);
    var key = CryptoJS.enc.Latin1.parse("!@#$%^&!@#$%^!@#"); //为了避免补位，直接用16位的秘钥
    var iv = CryptoJS.enc.Latin1.parse("!@#$%^&!@#$%^!@#"); //16位初始向量
    var encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    }).toString();
    return encrypted;
};
